const wibDate = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Asia/Jakarta", year: "numeric", month: "2-digit", day: "2-digit",
});

export function choiceDay(value) {
  if (!value) return "";
  const date = value?.toDate ? value.toDate() : new Date(value);
  if (!Number.isFinite(date.getTime())) return "";
  return wibDate.format(date);
}

export function choiceTimestamp(day) {
  if (!day) return null;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) throw new Error("Invalid choice date");
  const date = new Date(`${day}T23:59:59.999+07:00`);
  if (!Number.isFinite(date.getTime()) || choiceDay(date) !== day) throw new Error("Invalid choice date");
  return date.toISOString();
}

export function formatChoiceDate(value, lang = "id") {
  if (!choiceDay(value)) return "";
  const date = value?.toDate ? value.toDate() : new Date(value);
  return new Intl.DateTimeFormat(lang === "en" ? "en-GB" : "id-ID", {
    timeZone: "Asia/Jakarta", day: "numeric", month: "short", year: "numeric",
  }).format(date);
}
